import { OrderDirection } from '@core/constants';

export const fallbackSuperBetsConfig = {
    numberOfFeaturedSuperbets: 3,
    sortDirection: OrderDirection.Asc,
    oddsRangeValues: [
        1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9,
        2, 2.5, 3, 3.5, 4, 4.5, 5, 6, 7, 8,
        9, 10, 12, 14, 16, 18, 20, 25, 30, 35,
        40, 45, 50, 60, 70, 80, 90, 100, 200, 500, 1000,
    ],
};
